// extracted by mini-css-extract-plugin
export var list = "check_list-module--list--9a8af";